exports.isMobile = function () {
    var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
    var idx = 0;
    var isMobile = false;
    var userAgent = navigator.userAgent.toLowerCase();

    while (mobileAgentHash[idx] && !isMobile) {
        isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
        idx++;
    }
    return isMobile;
};